import styled from '@emotion/styled'

export const Line = styled.div`
    white-space: pre-line;
    `